export default "<p>print works!</p>\n";